module.exports = __webpack_public_path__ + "img/smileyrouge_on.8b920274.gif";